import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { Component, EventEmitter, Output } from "@angular/core";
import { ReportsService, ActiveControlledMedicationOptions, NursingStation, Prescriber, ApiRequestDto, ApiRequestDtoActiveControlledMedicationOptions } from "../../api";
import { FacilitiesService } from "../../core";
import OrderTypeEnum = ActiveControlledMedicationOptions.OrderTypeEnum;
import { LoadingError, ErrorObjectTypeEnum } from "../../core/error-catching.service";
import { catchError } from "rxjs/operators";

enum WizardPage {
    OrderType = 1,
    NursingStations = 2,
    Prescribers = 3
}

@Component({
    selector: 'my-active-controlled-medications-modal',
    templateUrl: 'active-controlled-medications-modal.component.html',
    styleUrls: ['active-controlled-medications-modal.component.scss']
})
export class ActiveControlledMedicationsModal extends DownloadFileContentModal{

    reportName: string = "Active Controlled Medications";
    title: string = "Download Active Controlled Medications";
    selectedPage: number = WizardPage.OrderType;
    MyWizardPage = WizardPage;
    hideSpinner:boolean = true;
    selectedOrderType: OrderTypeEnum = OrderTypeEnum.Both;
    includeGabapentin:boolean = true;
    allNursingStations: NursingStation[] = [];
    selectedNursingStations: NursingStation[] = [];
    allPrescribers: Prescriber[] = [];
    showDateRangeSelector: boolean = true;

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
    }

    show() {
        this.selectedPage = WizardPage.OrderType;
        this.selectedOrderType = OrderTypeEnum.Both;
        this.includeGabapentin = true;       
        super.show();
    }

    showNursingStationsPage() {
        this.hideSpinner = false;
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList
        };
        this.reportService.reportsGetNursingStations(requestParams).subscribe((result) => {
            this.allNursingStations = result;
            this.hideSpinner = true;
            this.selectedPage = WizardPage.NursingStations;
        });
    }

    hasSelectedNursingStations() : boolean {
        this.selectedNursingStations = this.allNursingStations.filter(ns => ns.IsSelected).slice();
        let result = this.selectedNursingStations.length > 0;
        return result;
    }

    showPrescribersPage() {
        this.hideSpinner = false;
        this.selectedNursingStations = this.allNursingStations.filter(ns => ns.IsSelected).slice();
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
            NursingStations: this.selectedNursingStations
        };
        this.reportService.reportsGetPrescribers(requestParams).subscribe((result) => {
            this.allPrescribers = result;
            this.hideSpinner = true;
            this.selectedPage = WizardPage.Prescribers;
        });            
    }
    
    canGenerateReport() : boolean {
        let selectedPrescribers = this.allPrescribers.filter(p => p.IsSelected).slice();
        let result = this.hideSpinner && this.hasSelectedNursingStations() && selectedPrescribers.length > 0;
        return result;
    }

    generateContent() {
        this.hideSpinner = false;
        let selectedPrescribers = this.allPrescribers.filter(p => p.IsSelected).slice();

        let options: ActiveControlledMedicationOptions = {
            IncludeGabapentin: this.includeGabapentin,
            OrderType: this.selectedOrderType,
            NursingStations: this.selectedNursingStations,
            Prescribers: selectedPrescribers
        };

        const requestParams: ApiRequestDtoActiveControlledMedicationOptions = { 
            OrgList: this.facilityService.selectedAsOrgList,
            _RequestOptions: options
        };
        this.reportService.reportsGetActiveControlledMedicationsReport(requestParams)
            .pipe(catchError((error) => {
                this.hideSpinner = true;
                throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
            }))
            .subscribe((result: Blob) => {
                this.downloadFile(result, "ActiveControlledMedications.xls");
                this.closeModal();
            });
    }

    back() {
        if (this.selectedPage > WizardPage.OrderType) {
            this.selectedPage--;
        }
    }
}